import React from 'react';
import classNames from 'classnames';

import styles from './LeagueName.module.scss';

const LeagueName = ({ categoryName, leagueName, countryCode }) => {
    return (
        <th colSpan='4' align='left'>
            <div className={'flex align-center'}>
                <div className={styles.leagueName}>
                    <div className={classNames(styles.flagContainer)}>
                        <img
                            alt={countryCode}
                            src={`/assets/flags/${
                                countryCode?.trim() ? countryCode.toLowerCase() : 'int'
                            }.svg`}
                            className={styles.flag}
                        />
                    </div>
                    <div>
                        {categoryName}, {leagueName}
                    </div>
                </div>
            </div>
        </th>
    );
};

export default LeagueName;
